import { IProduct } from "../../../services/payload/models/product";

export type IProductFilters = {
  [K in keyof IProduct]: IProduct[K]
}

export class ProductFilters implements IProductFilters {
  machineTypes: string[] = [];
  enginePowers: string[] = [];
  engineTypes: string[] = [];
  families: string[] = [];
  plants: string[] = [];
  platforms: string[] = [];
  seriesNames: string[] = [];
  subPlatforms: string[] = [];
  usagePeriods: string[] = [];

  constructor() {}
}
